export default     {
    path: '/dashboard/latest-releases',
    components: {
        default: () => import('../../views/memberDashboard/dashboard/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            name: 'memberDashboard.latestReleases',
            meta: {
                menuLabel: 'Latest Releases',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },

            component: () => import('../../views/memberDashboard/dashboard/components/latestReleases.vue'),
        },
    ]
}